<ul>
  @for (rule of passwordRules(); track $index) {
    <li [ngClass]="password()==='' ? '' : rule.satisfied ? 'valid' : 'invalid'">{{ rule.text }}</li>
  }
</ul>